// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#archive-listing-cases .stickyNavbar {\n  padding-bottom: 5px !important;\n}\n#archive-listing-cases .stickyNavbar .container-default {\n  padding-top: 0;\n  padding-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
